import { render, staticRenderFns } from "./ListCards.vue?vue&type=template&id=a24e72d0&scoped=true&"
import script from "./ListCards.vue?vue&type=script&lang=js&"
export * from "./ListCards.vue?vue&type=script&lang=js&"
import style0 from "./ListCards.vue?vue&type=style&index=0&id=a24e72d0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24e72d0",
  null
  
)

export default component.exports